import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import * as React from 'react';
import Axis from '../Axis';
import useChart from '../UseChart';

var XAxis = function XAxis(_ref) {
  var id = _ref.id,
      rest = _objectWithoutProperties(_ref, ["id"]);

  var chart = useChart();
  var isStockChart = chart.type === 'stockChart';
  var type = isStockChart ? 'datetime' : 'linear';
  var axisId = isStockChart ? 'xAxis' : id;
  return /*#__PURE__*/React.createElement(Axis, _extends({
    type: type
  }, rest, {
    id: axisId,
    isX: true
  }));
};

export default XAxis;